module.exports = __webpack_public_path__ + "src/img/banana/2.png?b524b2dc58eb9cb3cbe5c05807d3762d";


//////////////////
// WEBPACK FOOTER
// ./src/img/banana/2.png
// module id = 168
// module chunks = 0